const { LOCALE_MAP, LEGACY_MAP } = require('./constants');

const normalizeLocale = (locale) => LOCALE_MAP[locale] || LEGACY_MAP[locale] || locale;

module.exports = normalizeLocale;
